import DialogDefault from 'core/modules/components/dialogs/components/Dialog';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import './ChatImageModal.scss';

function ChatImageModal({ isOpen, imageSrc, imageName, onClose, t, title }) {
  const [showDownload, setShowDownload] = useState(false);

  const handleDownload = () => {
    if (!imageSrc) return;

    // Create a temporary anchor element to download the image
    const link = document.createElement('a');
    link.href = imageSrc;
    link.download = imageName || `image-${Date.now()}.png`;

    // For cross-origin images, we need to handle it differently
    if (imageSrc.startsWith('http') && !imageSrc.startsWith(window.location.origin)) {
      // Open in new tab for cross-origin images
      window.open(imageSrc, '_blank');
    } else {
      // Direct download for same-origin or data URLs
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <DialogDefault open={isOpen} onClose={onClose} title={title || imageName || t('chatbot:Image')} size="xl" hideHeader={false} separator>
      <div className="chat-image-modal-container" onMouseEnter={() => setShowDownload(true)} onMouseLeave={() => setShowDownload(false)}>
        {isOpen && imageSrc && (
          <>
            <img src={imageSrc} alt={imageName || t('chatbot:User uploaded image')} className="chat-image-modal__image" />
            {showDownload && (
              <button
                className="chat-image-modal__download-button"
                onClick={handleDownload}
                title={t('chatbot:Download image')}
                aria-label={t('chatbot:Download image')}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M12 15V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            )}
          </>
        )}
      </div>
    </DialogDefault>
  );
}

ChatImageModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  imageSrc: PropTypes.string,
  imageName: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  title: PropTypes.string,
};

ChatImageModal.defaultProps = {
  imageSrc: '',
  imageName: '',
  title: '',
};

export default withTranslation(['chatbot'])(ChatImageModal);
